import { render, staticRenderFns } from "./PopupBeritaAcara.vue?vue&type=template&id=5f1be2fa&scoped=true&"
import script from "./PopupBeritaAcara.vue?vue&type=script&lang=js&"
export * from "./PopupBeritaAcara.vue?vue&type=script&lang=js&"
import style0 from "./PopupBeritaAcara.vue?vue&type=style&index=0&id=5f1be2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1be2fa",
  null
  
)

export default component.exports